<script lang="ts" setup>
import { ButtonStyle } from '~/static/enums/components/button'
import AButton from '~/components/atoms/buttons/Button.vue'
import RModal from '~/components/organs/Modal.vue'

interface Props {
  name: string
}

defineProps<Props>()
const emit = defineEmits<{
  (e: 'delete'): void
}>()

const deleteFile = () => {
  emit('delete')
  closeModal()
}

const refModal: Ref = ref(null)
const closeModal = () => {
  if (refModal.value !== null) {
    refModal.value.closeModal()
  }
}
const openModal = () => {
  if (refModal.value !== null) {
    refModal.value.openModal()
  }
}
defineExpose({
  closeModal,
  openModal,
})

</script>

<template>
  <RModal
    ref="refModal"
    name-modal="deleteFileModal"
  >
    <template #header>
      <h5
        class="modal-title fs-5"
        id="deleteFileModalLabel"
      >
        Удалить файл?
      </h5>
    </template>
    
    <template #body>
      <div class="body">
        <span class="d-block mb-lg-3">Файл “{{ name }}” будет удалён. Его нельзя будет восстановить.</span>
      </div>
    </template>
    <template #footer>
      <AButton
        :button-style="ButtonStyle.Secondary"
        @click="closeModal"
      >
        Нет, оставить
      </AButton>
      <AButton
        :button-style="ButtonStyle.Danger"
        @click="deleteFile"
      >
        Да, удалить
      </AButton>
    </template>
  </RModal>
</template>

<style lang="scss" scoped></style>
